<!--
@name:图片预览
@description:用于详情相关业务模块单独处理
@author:hzw
@time:2021-03-16 16:00:24
-->
<template>
  <div class="images-box">
    <div class="image" v-for="image in attachments" :key="image.id">
      <el-image
        :z-index="2021"
        :style="imageStyle"
        :src="image.url"
        :preview-src-list="attachments.map(s=>s.url)"
        fit="fill"
      ></el-image>
      <div class="download" v-if="needDownload">
        <span class="action-item">
          <i class="el-icon-download" @click="downloadFile(image.id)"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getImgURLApi, downFileApi } from "../../../server/system";

export default {
  name: "viewImagePage",
  data() {
    return {
      attachments: [] //图片附件数组,已经转换过的图片地址
    };
  },
  props: {
    //图片宽高度
    imageStyle: {
      type: Object,
      default: () => {
        return {
          width: "100px",
          height: "100px"
        };
      }
    },
    needDownload: {
      type: Boolean,
      default: true
    },
    //附件id,可为附件guid字符串也可是数组
    attGuids: {
      // required: true,
      type: [String, Array]
    },
    //附件为字符串时,分隔符
    separate: {
      type: String,
      default: ","
    }
  },
  created() {
    this.getFileUrls();
  },
  mounted() {},
  watch: {
    attGuids(x) {
      this.getFileUrls();
    }
  },
  methods: {
    //获取附件地址
    getFileUrls() {
      let attrs = [];
      this.attachments = [];
      if (this.attGuids) {
        if (typeof this.attGuids === "string") {
          attrs = this.attGuids.split(this.separate);
        } else if (
          typeof this.attGuids === "object" &&
          Array.isArray(this.attGuids)
        ) {
          attrs = this.attGuids;
        }
        attrs.forEach(row => {
          getImgURLApi({ id: row }).then(result => {
            this.attachments.push({
              id: row,
              url: result.filePath
            });
          });
        });
      }
    },
    //
    //下载
    downloadFile(id) {
      downFileApi({ id: id })
        .then(res => {
          console.log(res.downLoadPath, "res.downLoadPath");
        })
        .catch(res => {
          // loading.close()
        });
    }
  }
};
</script>

<style lang="less">
.images-box {
  display: flex;

  .image {
    margin: 0 5px;
    width: 100px;
    height: 100px;
    position: relative;

    .download {
      width: 100%;
      height: 30px;
      background: rgba(1, 1, 1, 0.5);
      opacity: 0.8;
      position: absolute;
      bottom: 0;
      line-height: 30px;
      text-align: center;
      cursor: default;
      color: #fff;

      .action-item {
        cursor: pointer;

        &:hover {
          i {
            font-size: 20px;
          }
        }
      }

      i {
        font-size: 18px;
      }
    }
  }
}
</style>
